import React__default from 'react';
import { Box, Typography, Link, IconButton } from '@material-ui/core';
import RetryIcon from '@material-ui/icons/Replay';
import { StatusWarning, StatusOK, StatusError, StatusRunning, StatusPending, Table } from '@backstage/core-components';
import formatDistance from 'date-fns/formatDistance';
import { TravisIcon } from './travisIcon.esm.js';

const getStatusComponent = (status = "") => {
  switch (status.toLowerCase()) {
    case "queued":
    case "created":
      return /* @__PURE__ */ React__default.createElement(StatusPending, null);
    case "started":
      return /* @__PURE__ */ React__default.createElement(StatusRunning, null);
    case "failed":
      return /* @__PURE__ */ React__default.createElement(StatusError, null);
    case "passed":
      return /* @__PURE__ */ React__default.createElement(StatusOK, null);
    case "canceled":
    default:
      return /* @__PURE__ */ React__default.createElement(StatusWarning, null);
  }
};
const generatedColumns = [
  {
    title: "ID",
    field: "id",
    type: "numeric",
    width: "80px"
  },
  {
    title: "Build",
    field: "buildName",
    highlight: true,
    render: (row) => /* @__PURE__ */ React__default.createElement(Link, { href: row.buildUrl, target: "_blank", rel: "noopener noreferrer" }, row.buildName),
    sorting: false
  },
  {
    title: "Source",
    render: (row) => /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("p", null, row.source?.branchName), /* @__PURE__ */ React__default.createElement("p", null, row.source?.commit.hash)),
    sorting: false
  },
  {
    title: "Status",
    render: (row) => /* @__PURE__ */ React__default.createElement(Box, { display: "flex", alignItems: "center" }, getStatusComponent(row.status), /* @__PURE__ */ React__default.createElement(Box, { mr: 1 }), /* @__PURE__ */ React__default.createElement(Typography, { variant: "button" }, row.status)),
    width: "150px",
    sorting: false
  },
  {
    title: "Date",
    render: (row) => {
      return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("p", null, row.finishedAt ? `${formatDistance(/* @__PURE__ */ new Date(), new Date(row.finishedAt))} ago` : "In progress"), /* @__PURE__ */ React__default.createElement("p", null, row.duration, " sec"));
    },
    width: "150px",
    sorting: false
  },
  {
    title: "Actions",
    render: (row) => /* @__PURE__ */ React__default.createElement(IconButton, { onClick: row.onRestartClick }, /* @__PURE__ */ React__default.createElement(RetryIcon, null)),
    width: "100px",
    sorting: false
  }
];
const CITable = ({
  projectName,
  loading,
  pageSize,
  page,
  retry,
  builds,
  onChangePage,
  onChangePageSize,
  total
}) => {
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(
    Table,
    {
      isLoading: loading,
      options: { paging: true, pageSize },
      totalCount: total,
      page,
      actions: [
        {
          icon: () => /* @__PURE__ */ React__default.createElement(RetryIcon, null),
          tooltip: "Refresh Data",
          isFreeAction: true,
          onClick: retry
        }
      ],
      data: builds,
      onPageChange: onChangePage,
      onRowsPerPageChange: onChangePageSize,
      title: /* @__PURE__ */ React__default.createElement(Box, { display: "flex", alignItems: "center" }, /* @__PURE__ */ React__default.createElement(TravisIcon, null), /* @__PURE__ */ React__default.createElement(Box, { mr: 1 }), /* @__PURE__ */ React__default.createElement(Typography, { variant: "h6" }, projectName)),
      columns: generatedColumns
    }
  ));
};

export { CITable, getStatusComponent };
//# sourceMappingURL=CITable.esm.js.map
